<template>
  <div class="wraper">
    <div class="block" style="float:left;width: 100%;margin-bottom: 4px">
      <div style="padding-bottom: 10px">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="router">设备报表</el-breadcrumb-item>
          <el-breadcrumb-item>设备销售详情
            <el-tooltip placement="right">
              <div slot="content">
                设备销售详情：当前分组内所有设备SKU的销售数量及销售金额统计
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-breadcrumb-item>
          <el-breadcrumb-item> 资产号：{{ setting.assetsNum }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class='top'>
        <div class="export_btn">
          <exporter
            :setting='setting'
            :url='getListUrl'
            :date='date'
            :exportName="exportName"
          ></exporter>
        </div>
        <el-select v-model="setting.groupType" size='mini' placeholder="请选择">
          <el-option
            key="goods"
            label="按商品名称"
            value="goods">
          </el-option>
          <el-option
            key="times"
            label="按销售时间"
            value="times">
          </el-option>
        </el-select>
        <el-date-picker
          size='mini'
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable='clearDate'
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-button size="mini" type="primary" @click='search'>查询</el-button>
      </el-row>
      <el-row>
        <report
          :setting='setting'
          :list='list'
          @changeSort='handleSun'
        ></report>
        <el-row class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'

    export default {
        name: 'reports',
        components: {
            Report,
            exporter
        },
        data() {
            return {
                exportName:"设备销售详情",
                router: '/device',
                getListUrl: 'data/getDataReport_SalesDetailList',
                currentPage: 1,
                date: [],
                setting: {
                    groupType: "goods",
                    assetsNum: '',
                    isShowSelect: false,
                    isShowIndex: true,
                    tHeader: [{
                        dataItem: 'dateTime',
                        dataName: '销售时间',
                    }, {
                        dataItem: 'className',
                        dataName: '商品分类',
                    }, {
                        dataItem: 'goodsName',
                        dataName: '商品名称'
                    }, {
                        dataItem: 'price',
                        dataName: '单价(元)',
                    }, {
                        dataItem: 'salesNum',
                        dataName: '销售数量',
                    }, {
                        dataItem: 'salesAmount',
                        dataName: '销售金额',
                    }],
                    isShowPlay: false
                },
                list: [],
                total: 0,
                pageSize: 10,
                params: {},
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - (1000 * 60 * 60 * 24);
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, start]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date: [],
                clearDate: false,
                order:'',
                prop:''
            }
        },
        mounted() {
            this.params = this.$route.query;
            this.date = this.params.date;
            this.setting.assetsNum = this.params.assetsNum
            this.getDetail();
        },
        methods: {
            getDetail() {
                let params = {
                    assetsNum: this.setting.assetsNum,
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    startDay: this.date[0],
                    endDay: this.date[1],
                    groupByParam : this.setting.groupType,
                    order : this.order,
                    prop : this.prop
                };
                let _this = this;
                this.$ajax.post( this.getListUrl, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getList(val) {
                let params = {
                    assetsNum: this.setting.assetsNum,
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    startDay: this.date[0],
                    endDay: this.date[1],
                    groupByParam : this.setting.groupType
                };
                if (val != undefined) {
                    params.order = this.order = val.order;
                    params.prop = this.prop = val.prop;
                }
                let _this = this;
                this.$ajax.post( this.getListUrl, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {
                    const data = res.data.data;
                    console.log(data)
                    this.list = data.list;
                    this.total = data.total;
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getDetail(this.$route.params)
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getDetail(this.$route.params)
            },
            handleSun(val) {
                this.getList(val);
            },
            search() {
                this.getDetail(this.params);
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/deviceDetail.vue